import { render, staticRenderFns } from "./OperationConfigCatGather.vue?vue&type=template&id=296c24b2&scoped=true"
import script from "./OperationConfigCatGather.vue?vue&type=script&lang=js"
export * from "./OperationConfigCatGather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c24b2",
  null
  
)

export default component.exports